import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/LeadAdvertisementReport";

export const GetPerformance = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Performance`, options);

export const GetPerformanceDetails = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Performance/Details`, options);

export const GetTags = (options) => GENERATE_URL(`${PREFIX_URL}/Tags`, options);

export const GetTagDetails = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Tags/Details`, options);

export const GetSummary = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Summary`, options);

export default {
  GetSummary,
  GetPerformance,
  GetPerformanceDetails,
  GetTags,
  GetTagDetails,
};
